import request from '@/utils/request.js'

// 获取 P2P 币种市场价
export function getP2PCurrencyMarkePrice(coin,currency_code){
  return request({
      method:'get',
      url: '/p2p/market-price',
      params:{
        coin,
        currency_code
      }
  })
}

// 获取币种市场价
export function getCurrencyMarkePrice(coin){
  return request({
      method:'get',
      url: '/sys/market-price',
      params:{
        coin
      }
  })
}

// 获取法币汇率
export function getCurrencyExchangeRate(name){
    return request({
        method:'get',
        url: '/sys/exchange-rate',
        params:{
            name
        }
    })
}




// WEBPACK FOOTER //
// ./src/api/ad.js